import React from "react";
import { BrowserRouter , Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectdRoutes";

/** Vistas */
import Login from "../pages/Login/Login";
import Home from "../pages/Home/home";
import Technician from "../pages/Technician/technician";
import Client from "../pages/Client/client";
import Category from "../pages/category/category";
import Publicity from "../pages/publicity/publicity";
import Suscription from "../pages/suscription/suscription";
import Promotion from "../pages/promotion/promotion";
import Categorie from "../pages/categorie/categorie";
import Report from "../pages/Report/report";
import Activity from "../pages/Activity/Activities";
import Partner from "../pages/Partner/partner";
import PartnerCompanies from "../pages/PartnerCompanies/partnerCompanies";

const AppRoutes = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />

                <Route element={<ProtectedRoute roles={["Administrativo"]} permissions={["access-dashboard"]}/>}>
                    <Route path="/Home" element={<Home />} />
                </Route>
                <Route element={<ProtectedRoute roles={["Administrativo","Soporte"]} permissions={["manage-technician"]} />}>
                    <Route path="/Control-Tecnico" element={<Technician />} />
                </Route>
                <Route element={<ProtectedRoute roles={["Administrativo","Soporte"]} permissions={["manage-partners"]} />}>
                    <Route path="/Tecnicos-Partner" element={<Partner />} />
                </Route>
                <Route element={<ProtectedRoute roles={["Administrativo","Soporte"]} permissions={["manage-partners"]} />}>
                    <Route path="/Empresas-Partner" element={<PartnerCompanies />} />
                </Route>
                <Route element={<ProtectedRoute roles={["Administrativo","Soporte"]} permissions={["manage-clients"]} />}>
                    <Route path="/Control-cliente" element={<Client />} />
                </Route>
                <Route element={<ProtectedRoute roles={["Administrativo","Comercial"]} permissions={["view-publicity"]} />}>
                    <Route path="/Publicidad" element={<Publicity />} />
                </Route>
                <Route element={<ProtectedRoute roles={["Administrativo"]} permissions={["manage-users-roles"]} />}>
                    <Route path="/Categorias" element={<Category />} />
                </Route>
                <Route element={<ProtectedRoute roles={["Administrativo","Comercial"]} permissions={["manage-subcription"]} />}>
                    <Route path="/Suscripciones" element={<Suscription />} />
                </Route>
                {/*<Route element={<ProtectedRoute roles={["Administrativo","Comercial"]} permissions={["view-promotion"]} />}>
                    <Route path="/Promocion" element={<Promotion />} />
                </Route>*/}
                <Route element={<ProtectedRoute roles={["Administrativo","Soporte"]} permissions={["view-manage-actividade"]} />}>
                    <Route path="/Actividades" element={<Activity />} />
                </Route>
                <Route element={<ProtectedRoute roles={["Administrativo","Soporte"]} permissions={["manage-categories"]} />}>
                    <Route path="/Categoria" element={<Categorie />} />
                </Route>
                <Route element={<ProtectedRoute roles={["Administrativo"]} permissions={["reports"]} />}>
                    <Route path="/Reportes" element={<Report />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default AppRoutes;
